import tmt from './Templater.js';
import strings from '../modules/common/constants/strings';

const defaultMessage = {
    type: 'unmanaged',
    message: tmt('msg_failure_500')
}

const parse =  function(error) {
    if(!error.message) {
        return defaultMessage;
    }

    switch(error.message) {
        case 'validation':
            return {
                type: 'validation',
                message: tmt('msg_failure_400_validation'),
                fields: error.fields,
                // Real per-field validator text + the flat list of every message,
                // forwarded from the API so callers can show them verbatim.
                fieldMessages: error.fieldMessages || {},
                messages: error.messages || []
            }
        case 'bad_credentials':
            return {
                type: 'unauthorised',
                message: tmt('msg_authentication_failure_401')
            }
        case 'unauthorized':
            return {
                type: 'unauthorized',
                message: tmt('msg_authorization_missing')
            }
        default:
            throw error;
    }
}

// `errors` is the per-field category map; `fieldMessages` (optional) is the
// per-field actual validator text from the API. Prefer the real message so the
// form shows exactly what failed, falling back to the generic per-category
// string when the API didn't supply one.
const mapValidationErrors = (errors, fieldMessages = {}) => {
    let parsedErrors = {}
    for(let i in errors) {
        parsedErrors[i] = fieldMessages[i] || strings[`error_validation_${errors[i]}`];
    }

    return parsedErrors;
}

const ErrorHandler = {
    parse,
    mapValidationErrors
}

export default ErrorHandler;